export default "__VITE_ASSET__FNQLyKU6__"